import { useAuth } from 'contexts/auth';
import InstructorAssignmentFeedbackPage from 'pages/InstructorAssignmentFeedback';
import InstructorViewAssignmentFeedbackPage from 'pages/InstructorViewAssignmentFeedback';
import StudentViewAssignmentFeedbackPage from 'pages/StudentViewAssignmentFeedback';
import { useParams } from 'react-router-dom';

const AssignmentFeedbackPage = () => {
    const { auth } = useAuth();
    const { feedbackId } = useParams();

    if (auth.role === 'instructor') {
        return feedbackId ? <InstructorViewAssignmentFeedbackPage /> : <InstructorAssignmentFeedbackPage />;
    }
    if (auth.role === 'ta') {
        return feedbackId ? <InstructorViewAssignmentFeedbackPage /> : <InstructorAssignmentFeedbackPage />;
    }
    if (auth.role === 'student') {
        return <StudentViewAssignmentFeedbackPage />;
    }

    return null;
};

export default AssignmentFeedbackPage;
